export const GROUP_IDS = {
	ADMIN: '368ea6df-6a1c-4fa7-8786-fd4957be2290'
};
